import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  GlobalSearchResult,
  type GlobalSearchResultConstructor,
} from './GlobalSearchResult'
import { type GlobalSearchResultTypeEnum } from '../enums'

export const GlobalSearchResultConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultConstructor>({
    items: [],
    counts: new Map<GlobalSearchResultTypeEnum, number>(),
    total: 0,
    isTruncated: false,
    isUnsupportedQuery: false,
  })

export const GlobalSearchResultFactory = EntityFactory(
  GlobalSearchResult,
  GlobalSearchResultConstructorFactory
)
